
export enum MsgIDs {
    Client2ProxyReqLogin = 1000001, // 客户端登录请求
    Client2ProxyAckLogin = 1000002, // 客户端登录返回

    Client2ProxyReqAppleLogin = 1000306,   // 客户端请求APPLE账号登录(包含注册)

    Client2SrvHeartBeatReq = 1000003, // 客户端与ProxySVR心跳
    Client2SrvHeartBeatAck = 1000004, // 客户端与ProxySVR心跳
    Client2ProxyReqLogout = 1000005, // 客户端请求退出
    Client2ProxyAckLogout = 1000006, // 客户端请求退出返回
    Client2ProxyReqPokerProduct = 1000007, // 客户端请求获取德州产品列表
    Client2ProxyAckPokerProduct = 1000008, // 客户端请求获取德州产品列表返回
    Client2ProxyReqEnterGame = 1000009, // 客户端请求进入游戏
    Client2ProxyAckEnterGame = 1000010, // 客户端请求进去游戏返回
    Client2ProxyReqMobileRegister = 1000011, // 客户端请求手机号码注册
    Client2ProxyAckMobileRegister = 1000012, // 客户端请求手机号码注册返回
    Client2ProxyReqMobileSmsCode = 1000013, // 客户端请求手机验证码
    Client2ProxyAckMobileSmsCode = 1000014, // 客户端请求手机验证码返回
    Client2ProxyReqMobileResetPwd = 1000015, // 客户端请求重新设置密码
    Client2ProxyAckMobileResetPwd = 1000016, // 客户端请求重新设置密码返回

    Client2ProxyReqLeaveGame = 1000017, // 客户端请求离开游戏
    Client2ProxyAckLeaveGame = 1000018, // 客户端请求离开游戏返回
    Client2ProxyAckPlayerArrive = 1000019, // 给客户端推送玩家到达   
    Client2ProxyReqPlayerSitDown = 1000020, // 玩家坐下请求
    Client2ProxyAckPlayerSitDown = 1000021, // 玩家坐下请求返回
    Client2ProxyReqPlayerStandUp = 1000022, // 玩家站立请求
    Client2ProxyAckPlayerStandUp = 1000023, // 玩家站立请求返回
    Client2ProxyPushGoldChange = 1000024, // 推送用户金币变化
    Client2ProxyPushLight = 1000025, // 广播跑马灯消息 
    Client2ProxyReqSwitchTable = 1000026, // 客户端请求换桌
    Client2ProxyAckSwitchTable = 1000027, // 客户端请求换桌返回
    Client2ProxyPushPayNotiy = 1000028, // 用户充值结果
    Client2ProxyReqWithDraw = 1000029, // 客户端请求提现
    Client2ProxyAckWithDraw = 1000030, // 客户端请求提现返回
    Client2ProxyReqGetToken = 1000031, // 客户端请求token
    Client2ProxyAckGetToken = 1000032, // 客户端请求token返回

    Client2ProxyReqGetBalance = 1000033, // 点击头像刷新数据
    Client2ProxyAckGetBalance = 1000034, // 客户端请求获取银行数据返回
    Client2ProxyReqWithDrawRecord = 1000035, // 客户端请求获取提现记录
    Client2ProxyAckWithDrawRecord = 1000036, // 客户端请求获取提现记录返回
    Client2ProxyKickOutUser = 1000037, // 服务器踢用户
    Client2ProxyUserBreak = 1000038, // 玩家断线
    Client2ProxyUserResume = 1000039, // 玩家重连
    Client2ProxyAckTeenPattiProduct = 1000040, // 客户端请求获取赢三张产品列表返回
    Client2ProxyPushSysMsg = 1000041, // 推送玩家系统消息
    Client2ProxyReqCheckMobileUsed = 1000042, // 客户端请求检查手机号码是否被注册
    Client2ProxyAckCheckMobileUsed = 1000043, // 客户端请求检查手机号码是否被注册返回
    Client2ProxyReqGetProductList = 1000044, // 客户端请求获取产品列表
    Client2ProxyReqAckProductList = 1000045, // 客户端请求获取产品列表返回
    Client2ProxyReqModifyNickName = 1000046, // 客户端请求修改昵称
    Client2ProxyAckModifyNickName = 1000047, // 客户端请求修改昵称返回
    Client2ProxyPushModityHead = 1000048, // 推送玩家修改头像消息

    Client2ProxyReqModifyPlayHead = 1000103,    //客户端请求修改头像
    Client2ProxyAckModifyPlayHead = 1000104,    //客户端请求修改头像返回

    Client2ProxyReqMoblieLogin = 1000049, // 客户端请求手机号码登录(包含注册)
    Client2ProxyAckMoblieLogin = 1000050, // 客户端请求手机号码登录返回
    Client2ProxyReqTokenLogin = 1000051, // 客户端Token登录
    Client2ProxyAckTokenLogin = 1000052, // 客户端Token登录返回
    Client2ProxyReqRebateRecord = 1000053, // 客户端查询返佣信息
    Client2ProxyAckRebateRecord = 1000054, // 客户端查询返佣信息响应
    Client2ProxyReqSetAgent = 1000055, // 客户端设置玩家的上级代理
    Client2ProxyAckSetAgent = 1000056, // 客户端设置玩家的上级代理结果
    Client2ProxyPushSysMain = 1000057, // 服务器推送系统维护消息
    Client2ProxyReqRebateInfo = 1000058, // 客户端请求返佣信息
    Client2ProxyAckRebateInfo = 1000059, // 返回返佣信息
    Client2ProxyReqTime = 1000060, // 客户端请求服务器时间
    Client2ProxyAckTime = 1000061, // 响应客户端请求服务器时间
    Client2ProxyPushSimulator = 1000062, // 客户端推送模拟器信息
    Client2ProxyPushInGame = 1000063, // 推送是否在游戏中
    Client2ProxyPushLBSInfo = 1000064, // 推送用户LBS信息
    Client2ProxyReqIsPay = 1000067, // 是否是充值用户请求
    Client2ProxyAckIsPay = 1000068, // 是否是充值用户返回
    Client2ProxyTransWebMsg = 1000069, // 透传消息(web服务器透传过来的消息)
    Client2ProxyReqGetKyc = 1000070, // 客户端请求是否KYC
    Client2ProxyAckGetKyc = 1000071, // 客户端请求是否KYC返回
    Client2ProxyReqCheckKycInfo = 1000072, // 客户端请求检查KYC信息
    Client2ProxyAckCheckKycInfo = 1000073, // 客户端请求检查KYC信息返回
    Client2ProxyReqCheckSms = 1000074, // 客户端检查手机验证码
    Client2ProxyAckCheckSms = 1000075, // 客户端检查手机验证码返回
    Client2ProxyReqGetGameCount = 1000076, // 客户端获取游戏把数
    Client2ProxyAckGetGameCount = 1000077,
    Client2ProxyReqGetPayRecord = 1000078, // 客户端获取充值记录
    Client2ProxyAckGetPayRecord = 1000079, // 客户端获取充值记录返回
    Client2ProxyReqPidPlayerCount = 1000080, // 客户端获取每场人数
    Client2ProxyAckPidPlayerCount = 1000081, // 客户端获取每场人数返回

    Client2ProxyReqDaliyCheckInConfig = 1000082, // 客户端获取每日签到配置
    Client2ProxyAckDaliyCheckInConfig = 1000083, // 客户端获取每日签到配置返回
    Client2ProxyReqDaliyCheckIn = 1000084, // 客户端获取每日签到
    Client2ProxyAckDaliyCheckIn = 1000085, // 客户端获取每日签到返回
    Client2ProxyReqGetCumulativeDays = 1000086, // 客户端获取累计签到天数
    Client2ProxyAckGetCumulativeDays = 1000087, // 客户端获取累计签到天数返回
    Client2ProxyReqPayment = 1000088, // 客户端请求下单
    Client2ProxyAckPayment = 1000089, // 客户端请求下单

    Client2ProxyReqRazorPayKey = 1000090, // 客户端请求Razorpay秘钥信息
    Client2ProxyAckRazorPayKey = 1000091, // 客户端请求Razorpay秘钥信息返回
    Client2ProxyReqRazorPayOrderID = 1000092, // 客户端请求Razorpay获取订单
    Client2ProxyAckRazorPayOrderID = 1000093, // 客户端请求Razorpay获取订单返回

    Client2ProxyReqGetMailCount = 1000094, // 获取未读邮件数量
    Client2ProxyAckGetMailCount = 1000095, // 获取未读邮件数量
    Client2ProxyReqGetMailList = 1000096, // 获取邮件列表
    Client2ProxyAckGetMailList = 1000097, // 获取邮件列表
    Client2ProxyReqGetMailContent = 1000098, // 获取邮件内容
    Client2ProxyAckGetMailContent = 1000099, // 获取邮件内容
    Client2ProxyAckGetMailNeedUpdate = 1000100, // 获取邮件更新

    Client2ProxyReqCheckCashInfo = 1000101, // 客户端请求检查Cash信息
    Client2ProxyAckCheckCashInfo = 1000102, // 客户端请求检查Cash信息返回

    Client2ProxyReqGetGameList = 1000302,
    Client2ProxyAckGetGameList = 1000303,
    Client2ProxyReqCashMark = 1000304,
    Client2ProxyAckCashMark = 1000305,

    Client2ProxyReqNewPayRecord = 1000307, //客户端获取充值记录(新)
    Client2ProxyAckNewPayRecord = 1000308, //客户端获取充值记录返回(新)

    Client2ProxyReqBalanceDetail = 1000309, //客户端获取余额明细
    Client2ProxyAckBalanceDetail = 1000310, //客户端获取余额明细返回

    Client2ProxyReqActivityDetail = 1000311, //客户端获取余额明细
    Client2ProxyAckActivityDetail = 1000312, //客户端获取余额明细返回

    Client2ProxyReqAppleCancel = 1000313, // 客户端请求APPLE账号注销
    Client2ProxyAckAppleCancel = 1000314,

    DeskToGamSrvReqEmoji = 1010003, // 玩家使用互动表情
    DeskToGamSrvAckEmoji = 1010004, // 玩家使用互动表情

    GameSrvToDeskPushTimer = 3005014, // 定时器
    GameSrvToDeskPushStartGame = 3005015, // 服务器推送开始游戏
    GameSrvToDeskPushCommand = 3005016, // 服务器推送玩家操作命令       
    DeskToGameSrvPlayerCommandReq = 3005019, // 玩家操作请求
    DeskToGameSrvPlayerCommandAck = 3005020, // 玩家操作请求返回
    GameSrvToDeskPushDealCard = 3005018, // 发牌   
    GameSrvToDeskPushPlayingInfo = 3005017, // 牌桌内游戏信息，用于断线重连、中途加入,恢复牌局筹码等信息
    DeskToGameSrvPlayerShowCardReq = 3005021, // 玩家请求看牌
    DeskToGameSrvPlayerShowCardAck = 3005022, // 玩家请求看牌返回  
    GameSrvToDeskPushGameResult = 3005023, // 游戏结束    
    GameSrvToDeskPushKickPlayer = 3005024, // 踢出玩家
    GameSrvToDeskPushStateMachine = 3005027, // 给客户端发送状态机信息
    PokerSrvToDeskPushAssetInfo = 3005028, // 给客户端发送资产信息

    TeenPattiSrvToDeskPushAssetInfo = 3007001, // 服务器推送资产信息
    TeenPattiSrvToDeskPushStartGame = 3007002, // 服务器推送赢三张开始游戏
    TeenPattiSrvToDeskPushCommandTips = 3007003, // 服务器推送赢三张操作提示
    DeskToTeenPattiSrvPlayerCommandReq = 3007004, // 玩家赢三张操作
    DeskToTeenPattiSrvPlayerCommandAck = 3007005, // 广播玩家赢三张操作
    DeskToTeenPattiSrvPushCompareResult = 3007006, // 服务器推送赢三张操作SidesShow、Show结果
    Desk2TeenPattiSrvPushGameResult = 3007007, // 赢三张游戏结束
    Desk2TeenPattiSrvWaitForCharge = 3007009, // 玩家请求等待充值
    Desk2TeenPattiSrvPushPlayingInfo = 3007010, // 游戏开始后，用于断线重连、中途加入
    DeskToTeenPattiSrvPlayerCompareReq = 3007011, // 玩家赢三张操作是否响应比牌
    TeenPattiSrvToDeskPushDeskInfo = 3007012, // 给玩家发送游戏规则限制

    RummySrvToDeskPushPlayingInfo = 3007059, // Rummy牌桌内游戏信息，用于断线重连
    RummySrvToDeskPushStartGame = 3007057, // Rummy牌桌内游戏信息，游戏开始
    RummySrvToDeskPushDealCard = 3007052, // Rummy牌桌内游戏信息，发手牌
    RummySrvToDeskPushPublicCard = 3007053, // Rummy牌桌内游戏信息，发公共牌
    RummySrvToDeskPushMagicCard = 3007054, // Rummy牌桌内游戏信息，发万能牌
    DeskToRummySrvPlayerCommandReq = 3007055, // Rummy牌桌内游戏信息，客户端向服务器发操作消息
    DeskToRummySrvPlayerCommandAck = 3007056, // Rummy牌桌内游戏信息，客户端向服务器发操作消息 后的返回
    RummySrvToDeskPushGameResult = 3007060, // Rummy牌桌内游戏信息，发游戏结束消息
    RummySrvToDeskPushAssetInfo = 3007062, // Rummy牌桌内游戏信息，资产更新消息

    RummyPoolSrvToDeskPushAssetInfo = 3007063, // PoolRummy牌桌内游戏信息，资产更新消息
    RummyPoolSrvToDeskPushRuleInfo = 3007064, // PoolRummy牌桌内游戏信息，牌局信息
    RummyPoolSrvToDeskPushRoundInfo = 3007065, // PoolRummy牌桌内游戏信息，积分列表，客户端向服务器发操作消息 后的返回
    DeskToRummyPoolSrvRoundInfoReq = 3007066, // PoolRummy牌桌内游戏信息，客户端向服务器发 请求牌局输赢信息
    RummyPoolSrvToDeskPushPlayerGameEnd = 3007067, // PoolRummy牌桌内游戏信息，通知玩家游戏结束(玩家Out或总结算)

    RummyDealesSrvToDeskPushDealerCard = 3007068, // DealeRummy牌桌内游戏信息，发牌前玩家比牌信息
    DeskToRummyDealesSrvResultReq = 3007069, // DealeRummy牌桌内游戏信息，请求游戏结果
    RummyDealesSrvToDeskPushGameResult = 3007070, // DealeRummy牌桌内游戏信息，推送游戏结果
    RummyDealesSrvToDeskPushMaxPlayerCnt = 3007071, // DealeRummy牌桌内游戏信息，推送游戏开局最大人数
    RummyDealesSrvToDeskPushGameEnd = 3007072, // DealeRummy牌桌内游戏信息，推送游戏结束信息
    RummyDealesSrvToDeskGameEndReq = 3007073, // DealeRummy牌桌内游戏信息，玩家请求游戏总结束信息
    RummySrvToDeskPushShuffleCards = 3007074, // 通知玩家重新洗牌(洗牌动画)

    Desk2TreasureSrvCurrentParticipationReq = 3007801, // 本期所有玩家参与信息
    Desk2TreasureSrvCurrentParticipationAck = 3007802, // 本期所有玩家参与信息返回
    Desk2TreasureSrvPlayerParticipationReq = 3007803, // 玩家往期参与过的信息
    Desk2TreasureSrvPlayerParticipationAck = 3007804, // 玩家往期参与过的信息返回
    Desk2TreasureSrvPastRecordsReq = 3007805, // 查询往期记录
    Desk2TreasureSrvPastRecordsAck = 3007806, // 查询往期记录返回
    Desk2TreasureSrvTickNumberReq = 3007807, // 查询奖券号码
    Desk2TreasureSrvTickNumberAck = 3007808, // 查询奖券号码返回
    Desk2TreasureSrvQueryLotteryReq = 3007809, // 夺宝查询本期基本信息请求
    Desk2TreasureSrvQueryLotteryAck = 3007810, // 夺宝查询本期基本信息请求返回
    Desk2TreasureSrvByTicketReq = 3007811, // 购买本期
    Desk2TreasureSrvByTicketAck = 3007812, // 购买本期返回
    Desk2TreasureSrvPushResultTimeout = 3007813, // 本期等待揭晓
    Desk2TreasureSrvPushResult = 3007814, // 本期揭晓
    Desk2TreasureSrvPushProductList = 3007815, // 夺宝所有场次信息

    BigBattleSrvToDeskPushAssetInfo = 3008102, // lhd服务器推送资产信息
    BigBattleSrvToDeskPushDeskInfo = 3008103, // lhd给玩家发送游戏规则限制
    Desk2BigBattleSrvPushPlayingInfo = 3008104, // lhd游戏开始后，用于断线重连、中途加入
    Client2BattleSrvReqBet = 3008105, // lhd玩家请求压注
    Client2BattleSrvAckBet = 3008106, // lhd玩家请求压注返回
    Desk2BigBattleSrvPushGameCard = 3008107, // 推送游戏发牌信息
    Desk2BigBattleSrvPushGameResult = 3008108, // lhd游戏结束
    Desk2BigBattleSrvPushRandPlayer = 3008109, // lhd推送玩家排名
    Desk2BigBattleSrvPushTrend = 3008110, // lhd推送开奖趋势、预测和输赢记录
    Desk2BigBattleSrvPushLuckyStar = 3008112, // lhd给机器人推送幸运星区域

    PokerWarSrvToDeskPushAssetInfo = 3008202, // PokerWar服务器推送资产信息
    PokerWarSrvToDeskPushDeskInfo = 3008203, // PokerWar给玩家发送游戏规则限制
    Desk2PokerWarSrvPushPlayingInfo = 3008204, // PokerWar游戏开始后，用于断线重连、中途加入
    Client2PokerWarSrvReqBet = 3008205, // PokerWar玩家请求压注
    Client2PokerWarSrvAckBet = 3008206, // PokerWar玩家请求压注返回
    Desk2PokerWarSrvPushGameCard = 3008207, // PokerWar推送游戏发牌信息
    Desk2PokerWarSrvPushGameResult = 3008208, // PokerWar红黑大战游戏结束
    Desk2PokerWarSrvPushRandPlayer = 3008209, // PokerWar推送玩家排名
    Desk2PokerWarSrvPushTrend = 3008210, // PokerWar推送开奖趋势、预测和输赢记录
    Desk2PokerWarSrvPushLuckyStar = 3008211, // PokerWar给玩家推送幸运星区域

    Client2ProxyReqAgentRebate = 1000315, // 客户端请求代理汇总数据
    Client2ProxyAckAgentRebate = 1000316,
    Client2ProxyReqAgentRebateInfo = 1000317, // 客户端请求代理返利明细
    Client2ProxyAckAgentRebateInfo = 1000318,
    Client2ProxyReqAgentGetRebate = 1000319, // 客户端请求领取返利
    Client2ProxyAckAgentGetRebate = 1000320,

    Client2ProxyReqNewPayUpdate = 1000321, // 客户端充值记录状态修改(新)
    Client2ProxyAckNewPayUpdate = 1000322,

    DeskToTeenPattiSrvRecordCommandReq = 3007014,
    DeskToTeenPattiSrvRecordCommandAck = 3007015,

    Client2ProxyReqNewHand = 1000105, // 客户端请求获取玩家游戏场次统计
    Client2ProxyAckNewHand = 1000106,

    Client2ProxyReqRecordAF = 1000107, // 客户端请求记录玩家AF事件信息
    Client2ProxyAckRecordAF = 1000108,

    GameSrvToClientHandGroupData = 3007078, // 通知客户端下发当前玩家手牌牌组

    ClientActivityDataPush = 1000334, // 活动数据推送

    ClientBrokeDataInf = 1000335, // 破产数据推送

    ClientJackPotDataReq = 1000337,     // 客户端游戏JACKPOT列表数据请求
    ClientJackPotDataAck = 1000338,     // 客户端游戏JACKPOT列表数据回应

    PushPlayerStatus = 1000333,

    // ================ tp begin
    GameSrvToDeskCancelCharge = 3007016, // 客户端请求取消充值
    PushTeenPattinChargeGold = 3007018,
    // ================ tp end

    // ================ match begin
    Client2ProxyReqMatchList = 1000323,   // 客户端请求赛事列表
    Client2ProxyAckMatchList = 1000324,   // 客户端请求赛事列表
    Client2ProxyReqMatchSign = 1000325,   // 客户端请求赛事报名
    Client2ProxyAckMatchSign = 1000326,
    Client2ProxyReqMatchSignCancel = 1000327,   // 客户端请求取消赛事报名
    Client2ProxyAckMatchSignCancel = 1000328,
    Client2ProxyReqMatchSchedule = 1000329,   // 客户端请求赛事进度
    Client2ProxyAckMatchSchedule = 1000330,
    Client2ProxyPushMatchResult = 1000331,    // 推送玩家比赛结果
    // ================ match end

    // ========= test begin =======
    ShowCardRummy = 3007076, // 机器人显示牌
    ShowAiMessage = 3007049,

    RummySrvToDeskSuperDataReq = 3007098, // 游戏超端数据请求
    RummySrvToDeskSuperDataAck = 3007099,


    GameBotSrvSuperDataReq = 1000339, // AI服务超端数据请求
    GameBotSrvSuperDataAck = 1000340,

    ClientInviteDataReq = 3007968, //好友邀请活动请求
    ClientInviteDataAck = 3007969, //好友邀请活动返回
    ClientInviteGoldReq = 3007970, //好友邀请金币请求
    ClientInviteGoldAck = 3007971, //好友邀请金币返回
    ClientInviteTasktStatusReq = 3007972, //好友邀请活动状态
    ClientInviteTasktStatusAck = 3007973, //好友邀请活动状态返回
    ClientInviteAddGoldReq = 3007974, //好友邀请完成金币
    ClientInviteAddGoldAck = 3007975, //好友邀请完成金币返回

    ClientDrawNumReq = 1000346,  // 前端获取转盘抽奖次数
    ClientDrawNumAck = 1000347, //前端获取转盘抽奖次数返回
    ClientTurntableReq = 1000348,  // 前端请求转盘抽奖
    ClientTurntableAck = 1000349, //前端请求转盘抽奖返回


    ClientRankingDataReq = 1000350,    // 前端请求排行榜数据
    ClientRankingDataAck = 1000351,    // 前端请求排行榜数据返回
    ClientRankingJackPotReq = 1000352,    // 前端请求排行榜JackPot数据
    ClientRankingJackPotAck = 1000353,    // 前端请求排行榜JackPot数据返回
    ClientRankingPrizeGoldReq = 1000354,    // 前端请求排行榜是否中奖
    ClientRankingPrizeGoldAck = 1000355,  // 前端请求排行榜是否中奖返回
    ClientRankingGetPrizeReq = 1000356,    // 前端请求排行榜金币领取
    ClientRankingGetPrizeAck = 1000357,  // 前端请求排行榜金币领取返回

    //
    ClientCP2dBetReq = 1000358,  //  CP2d玩家请求下注
    ClientCP2dBetAck = 1000359,  //  CP2d玩家请求下注返回

    ClientCP2dNumRecordReq = 1000364,  //  前端请求CP2d累计下注号码
    ClientCP2dNumRecordAck = 1000365,  //  前端请求CP2d累计下注号码返回

    ClientCP3dBetReq = 1000366,//
    ClientCP3dBetAck = 1000367,
    ClientCP3dNumRecordReq = 1000368,
    ClientCP3dNumRecordAck = 1000369,

    ClientTurn3GiftReq = 1000370, // 前端请求转盘3礼包状态
    ClientTurn3GiftAck = 1000371, // 前端请求转盘3礼包状态返回  
    ClientTurn3PlayDataReq = 1000372, // 前端请求转盘3
    ClientTurn3PlayDataAck = 1000373, // 前端请求转盘3返回 
    ClientTurn3SpinReq = 1000374, // 前端请求转盘3旋转
    ClientTurn3SpinAck = 1000375, // 前端请求转盘3旋转返回 
    ClientTurn3PrizeReq = 1000376, // 前端请求转盘3礼包领取
    ClientTurn3PrizeAck = 1000377, // 前端请求转盘3礼包领取返回 
    ClientTurn3WinRecordReq = 1000378, // 前端请求转盘3WinRecord数据
    ClientTurn3WinRecordAck = 1000379, // 前端请求转盘3WinRecord数据返回
    ClientTurn3GiftGetReq = 1000380, // 前端请求转盘3礼包状态领取
    ClientTurn3GiftGetAck = 1000381, // 前端请求转盘3礼包状态领取返回  

    Client2ProxyRegisterReq = 1000382, // 玩家注册
    Client2ProxyRegisterAck = 1000383, // 玩家注册返回
    Client2ProxyLoggingReq = 1000384, // 玩家登录
    Client2ProxyLoggingAck = 1000385, // 玩家登录返回

    ClientLuckySpinGetReq = 1000388, // 获取流水大转盘信息
    ClientLuckySpinGetAck = 1000389, // 返回流水大转盘信息
    ClientLuckySpinPlayReq = 1000390, // 流水大转盘抽奖
    ClientLuckySpinPlayAck = 1000391, // 返回流水大转盘抽奖


    ClientSignActivityReq = 1000386,  //签到配置信息
    ClientSignActivityAck = 1000387,
    ClientSignActivityAggReq = 1000392,
    ClientSignActivityAggAck = 1000393,
    ClientSignActivityInReq = 1000394,
    ClientSignActivityInAck = 1000395,

    ClientFreeSpinReq = 1000396,   //获取免费转信息
    ClientFreeSpinAck = 1000397,   //返回免费转信息

    ClientEveryDayReq = 1000398, // 前端请求每日任务数据
    ClientEveryDayAck = 1000399, // 前端请求每日任务数据返回
    ClientEveryDayGoldReq = 1000400, // 前端请求领取每日任务奖励
    ClientEveryDayGoldAck = 1000401, // 前端请求领取每日任务奖励返回

    ClientBoxActReq = 1000402, // 前端请求神秘宝箱数据
    ClientBoxActAck = 1000403, // 前端请求神秘宝箱数据返回
    ClientBoxActGetReq = 1000404, // 前端请求寻宝数据
    ClientBoxActGetAck = 1000405, // 前端请求寻宝数据返回

    ClientGemActReq = 1000406, // 检测宝石活动激活
    ClientGemActAck = 1000407, // 检测宝石活动激活返回
    ClientGemDataReq = 1000408, // 请求宝石活动数据
    ClientGemDataAck = 1000409, // 请求宝石活动数据返回
    ClientGemGetReq = 1000410, // 请求宝石收集
    ClientGemGetAck = 1000411, // 请求宝石收集返回
    ClientGemPrizeReq = 1000412, // 请求宝石中奖奖励
    ClientGemPrizeAck = 1000413, // 请求宝石中奖奖励返回
    // ========= test end =======

    // // ========= mines begin =======
    // MineSweeperSrvToDeskPushDeskInfo = 3014103,
    // Client2MineSweeperSrvReqBet = 3014105,
    // Client2MineSweeperSrvAckBet = 3014106,
    // Client2MineSweeperSrvReqFlop = 3014107,
    // Client2MineSweeperSrvAckFlop = 3014108,
    // Desk2MineSweeperSrvPushGameResult = 3014109,
    // Desk2MineSweeperSrvPushPlayingInfo = 3014104,
    // Client2MineSweeperSrvReqEndFlop = 3014110,
    // Client2MineSweeperSrvAckEndFlop = 3014111,
    // // ========= mines end =======
}